<template>
  <a-drawer
    title="信息统计"
    :visible="visible"
    :width="480"
    @close="close"
    destroyOnClose
  >
    <a-spin :spinning="loading">
      <a-card size="small" class="stat-card">
        <a-statistic title="优惠券总数量" :value="stat.allNum" />
      </a-card>

      <a-card size="small" class="stat-card">
        <a-statistic title="优惠总金额" :value="stat.money" :precision="2" prefix="¥" />
      </a-card>

      <a-card size="small" class="stat-card">
        <a-statistic title="已使用数量" :value="stat.useNum" />
      </a-card>

      <a-card size="small" class="stat-card">
        <a-statistic title="未使用数量" :value="stat.noUseNum" />
      </a-card>

      <a-card size="small" class="stat-card">
        <a-statistic title="失效数量" :value="stat.noNum" />
      </a-card>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="close">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { infoStatUserCoupon } from '@/api/coupon/controller'

export default {
  name: 'UserCouponInfoStatDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      stat: {
        allNum: 0,
        money: 0,
        noNum: 0,
        noUseNum: 0,
        useNum: 0,
      },
    }
  },
  methods: {
    open({ userId, couponId }) {
      this.visible = true
      this.loading = true
      infoStatUserCoupon({ userId, couponId }).then(res => {
        this.stat = res.data
        this.loading = false
      })
    },
    close() {
      this.visible = false
      this.stat = {
        allNum: 0,
        money: 0,
        noNum: 0,
        noUseNum: 0,
        useNum: 0,
      }
    },
  },
}
</script>

<style scoped>
.stat-card {
  margin-bottom: 16px;
}
.drawer-footer {
  position: absolute;
  right: 16px;
  bottom: 16px;
  width: 100%;
  padding: 10px 16px;
  background: #fff;
  border-top: 1px solid #e9e9e9;
  text-align: right;
}
</style>
